export default "__VITE_ASSET__jNd8Y1qi__"